export default "/images/vendor/flag-icons/flags/4x3/ma.svg?ab052b412792b9fadd8c6a53bf717d63";